export default {
    GET_COLOR_SWATCH: '[PRODUCT] GET_COLOR_SWATCH',
    GET_COLOR_SWATCH_RESULT: '[PRODUCT] GET_COLOR_SWATCH_RESULT',
    GET_COLOR_SWATCH_ERROR: '[PRODUCT] GET_COLOR_SWATCH_ERROR',

    TYPE_GET_COLOR_SWATCH: 'get_color_swatch'
}



// WEBPACK FOOTER //
// ./src/view/constant/ColorSwatchConstant.js